import { render, staticRenderFns } from "./NLPTester.vue?vue&type=template&id=6fb1a299&"
import script from "./NLPTester.vue?vue&type=script&lang=js&"
export * from "./NLPTester.vue?vue&type=script&lang=js&"
import style0 from "./NLPTester.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports